<template>
  <div>
    <p>
      The payload is required to perform a performance analysis of the
      constellation, but it is not used to deploy the constellation.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipConstellationGeometryPayload'
}
</script>
